import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchLogout } from "./loginAPI";

export interface LoginState {
  logout: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: LoginState = {
  logout: {},
  status: "idle",
};

// export const GetLogout = createAsyncThunk(
//   "logIn/getLogout",
//   async () => {
//     const response = await fetchLogout();
//     return response;
//   }
// );
export const GetLogout = createAsyncThunk("user/logout", async () => {
  const response = await fetchLogout();
  return response;
});
export const LogoutSlice = createSlice({
  name: "Logout",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetLogout.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetLogout.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetLogout.fulfilled, (state, action) => {
        state.status = "success";
        
        state.logout = action.payload.Logout;
        if(action.payload.status == 302) {
        localStorage.removeItem("userDetails");
        localStorage.removeItem("otp");
        localStorage.removeItem("forgetpass");
        localStorage.removeItem("URP");
        localStorage.removeItem("store");
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("userPhotoDetails");
        }
        //history.push(`/`);
        window.location.href = "/";
      });
  },
});

export const {} = LogoutSlice.actions;

export const selectLogout = (state: RootState) => {
  return state.getLogout.logout;
};

export default LogoutSlice.reducer;
